export type UploadBatch = { id: string; revision_id: string; received: number[]; run_id: string | null };
type Request = <T>(path: string, init?: RequestInit) => Promise<T>;
type Cache = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export async function sendAutonomousBatch(revisionId: string, files: File[], building: string,
  request: Request, cache: Cache) {
  const signature = JSON.stringify([revisionId, building, files.map(f => [f.webkitRelativePath || f.name, f.size, f.lastModified])]);
  const cacheKey = "workbench-upload:" + signature;
  let requestKey = cache.getItem(cacheKey);
  if (!requestKey) {
    requestKey = crypto.randomUUID();
    cache.setItem(cacheKey, requestKey);
  }
  try {
    let batch = await request<UploadBatch>("/revisions/" + revisionId + "/upload-batches", {
      method: "POST", body: JSON.stringify({ request_key: requestKey,
        files: files.map(file => ({ path: [building, file.webkitRelativePath || file.name].filter(Boolean).join("/"),
          size: file.size, building })) }),
    });
    for (const [ordinal, file] of files.entries()) {
      // A name, byte size and mtime do not prove identical content after reselection.
      // Re-send received entries so the server verifies their complete SHA256.
      const body = new FormData();
      body.append("file", file);
      batch = await request<UploadBatch>("/upload-batches/" + batch.id + "/files/" + ordinal, { method: "POST", body });
    }
    const completed = await request<UploadBatch>("/upload-batches/" + batch.id + "/complete", { method: "POST" });
    cache.removeItem(cacheKey);
    return completed;
  } catch (error) {
    // Retain the key on a lost response; a completed server job must be recovered once.
    if (error instanceof Error && "status" in error && error.status === 409) cache.removeItem(cacheKey);
    throw error;
  }
}
